import http from '../http'

export default {
  // paifa商城注册
  paifaMallRegister(data: object, option: object = {}) {
    return http.post('/auth/web/mall/register', data, option)
  },
  // paifa商城登录
  paifaMallLogin(data: object, option: object = {}) {
    return http.post('/auth/web/mall/login', data, option)
  },
  // paifa商城临时登录
  paifaMallTempLogin(data: object, option: object = {}) {
    return http.post('/auth/web/mall/temp_login', data, option)
  },
  // paifa续票
  paifaExchangeTolen(data: object, option: object = {}) {
    return http.post('/auth/web/mall/exchange', data, option)
  },
  // 发送短信
  notifySms(data: object, option: object = {}) {
    return http.post('/auth/notify/sms', data, option)
  },
  // 获取paifa mall配置
  getPaifaMallConfig(data: object = {}, option: object = {}) {
    return http.post('/auth/pai_fa/mall/config', data, option)
  },
}
